/**
 * Generated by orval 🍺
 * Do not edit manually.
 * standard public schema
 * OpenAPI spec version: 16.1
 */
import type {
  DeleteUsersParams,
  GetUsersParams,
  PatchUsersParams,
  PostUsersParams,
  PostgrestError,
  Users,
  UsersInsertPayload,
  UsersUpdate
} from '../../models';

import {
  backendBaseUrl
} from '@/api/vtnz-backend/baseUrl';


export type HTTPStatusCode1xx = 100 | 101 | 102 | 103;
export type HTTPStatusCode2xx = 200 | 201 | 202 | 203 | 204 | 205 | 206 | 207;
export type HTTPStatusCode3xx = 300 | 301 | 302 | 303 | 304 | 305 | 307 | 308;
export type HTTPStatusCode4xx = 400 | 401 | 402 | 403 | 404 | 405 | 406 | 407 | 408 | 409 | 410 | 411 | 412 | 413 | 414 | 415 | 416 | 417 | 418 | 419 | 420 | 421 | 422 | 423 | 424 | 426 | 428 | 429 | 431 | 451;
export type HTTPStatusCode5xx = 500 | 501 | 502 | 503 | 504 | 505 | 507 | 511;
export type HTTPStatusCodes = HTTPStatusCode1xx | HTTPStatusCode2xx | HTTPStatusCode3xx | HTTPStatusCode4xx | HTTPStatusCode5xx;

export type getUsersResponse200 = {
  data: Users[]
  status: 200
}

export type getUsersResponse206 = {
  data: Users[]
  status: 206
}

export type getUsersResponseDefault = {
  data: PostgrestError
  status: Exclude<HTTPStatusCodes, 200 | 206>
}

export type getUsersResponseSuccess = (getUsersResponse200 | getUsersResponse206) & {
  headers: Headers;
};
export type getUsersResponseError = (getUsersResponseDefault) & {
  headers: Headers;
};

export type getUsersResponse = (getUsersResponseSuccess | getUsersResponseError)

export const getGetUsersUrl = (params?: GetUsersParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `${backendBaseUrl}/users?${stringifiedParams}` : `${backendBaseUrl}/users`
}

/**
 * @summary Read rows from `users`.
 */
export const getUsers = async (params?: GetUsersParams, options?: RequestInit): Promise<getUsersResponse> => {

  const res = await fetch(getGetUsersUrl(params),
  {
    ...options,
    method: 'GET'


  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: getUsersResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as getUsersResponse
}


export type postUsersResponse201 = {
  data: Users[]
  status: 201
}

export type postUsersResponseDefault = {
  data: PostgrestError
  status: Exclude<HTTPStatusCodes, 201>
}

export type postUsersResponseSuccess = (postUsersResponse201) & {
  headers: Headers;
};
export type postUsersResponseError = (postUsersResponseDefault) & {
  headers: Headers;
};

export type postUsersResponse = (postUsersResponseSuccess | postUsersResponseError)

export const getPostUsersUrl = (params?: PostUsersParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `${backendBaseUrl}/users?${stringifiedParams}` : `${backendBaseUrl}/users`
}

/**
 * @summary Insert one or more rows into `users`.
 */
export const postUsers = async (usersInsertPayload: UsersInsertPayload,
    params?: PostUsersParams, options?: RequestInit): Promise<postUsersResponse> => {

  const res = await fetch(getPostUsersUrl(params),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(usersInsertPayload)
  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: postUsersResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as postUsersResponse
}


export type patchUsersResponse200 = {
  data: Users[]
  status: 200
}

export type patchUsersResponseDefault = {
  data: PostgrestError
  status: Exclude<HTTPStatusCodes, 200>
}

export type patchUsersResponseSuccess = (patchUsersResponse200) & {
  headers: Headers;
};
export type patchUsersResponseError = (patchUsersResponseDefault) & {
  headers: Headers;
};

export type patchUsersResponse = (patchUsersResponseSuccess | patchUsersResponseError)

export const getPatchUsersUrl = (params?: PatchUsersParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `${backendBaseUrl}/users?${stringifiedParams}` : `${backendBaseUrl}/users`
}

/**
 * @summary Update the rows of `users` matching the given filters.
 */
export const patchUsers = async (usersUpdate: UsersUpdate,
    params?: PatchUsersParams, options?: RequestInit): Promise<patchUsersResponse> => {

  const res = await fetch(getPatchUsersUrl(params),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(usersUpdate)
  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: patchUsersResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as patchUsersResponse
}


export type deleteUsersResponse200 = {
  data: Users[]
  status: 200
}

export type deleteUsersResponseDefault = {
  data: PostgrestError
  status: Exclude<HTTPStatusCodes, 200>
}

export type deleteUsersResponseSuccess = (deleteUsersResponse200) & {
  headers: Headers;
};
export type deleteUsersResponseError = (deleteUsersResponseDefault) & {
  headers: Headers;
};

export type deleteUsersResponse = (deleteUsersResponseSuccess | deleteUsersResponseError)

export const getDeleteUsersUrl = (params?: DeleteUsersParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `${backendBaseUrl}/users?${stringifiedParams}` : `${backendBaseUrl}/users`
}

/**
 * @summary Delete the rows of `users` matching the given filters.
 */
export const deleteUsers = async (params?: DeleteUsersParams, options?: RequestInit): Promise<deleteUsersResponse> => {

  const res = await fetch(getDeleteUsersUrl(params),
  {
    ...options,
    method: 'DELETE'


  }
)


  const body = [204, 205, 304].includes(res.status) ? null : await res.text();

  const data: deleteUsersResponse['data'] = body ? JSON.parse(body) : {}
  return { data, status: res.status, headers: res.headers } as deleteUsersResponse
}


